import React from 'react';

type UseSessionTransitionLoadingParams = {
  sessionId?: string | null;
  resolvedSessionId?: string | null;
  isFetching: boolean;
  isError?: boolean;
  enabled?: boolean;
};

const useSessionTransitionLoading = ({
  sessionId,
  resolvedSessionId,
  isFetching,
  isError = false,
  enabled = true,
}: UseSessionTransitionLoadingParams) => {
  const activeSessionId = enabled ? sessionId || null : null;
  const isSettledForActiveSession = Boolean(
    activeSessionId && !isFetching && (resolvedSessionId === activeSessionId || isError)
  );
  const [settledSessionId, setSettledSessionId] = React.useState<string | null>(
    isSettledForActiveSession ? activeSessionId : null
  );

  React.useEffect(() => {
    if (!activeSessionId) {
      setSettledSessionId(null);
      return;
    }

    if (isSettledForActiveSession) {
      setSettledSessionId(activeSessionId);
    }
  }, [activeSessionId, isSettledForActiveSession]);

  return Boolean(activeSessionId && settledSessionId !== activeSessionId && !isSettledForActiveSession);
};

export default useSessionTransitionLoading;
